import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/lms-fonts.scss';
import './styles/lms-style.scss';
import './styles/swiper-bundle.min.scss';
import App from '../src/App';
import { Provider } from 'react-redux';
import { store } from '../src/store';

const root = ReactDOM.createRoot(document.getElementById('iccToppicksWebview'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
